import Colors from '@ziynx/theme/colors';

export const managerPermissions = [
  {
    icon: { name: 'checkmark-fill-circle', color: Colors.SecondaryGreen },
    text: 'This role can explore and interact with talent',
  },
  {
    icon: { name: 'clear', color: Colors.SecondaryRed },
    text: 'This role cannot manage team members',
  },
  {
    icon: { name: 'clear', color: Colors.SecondaryRed },
    text: 'This role cannot manage billing',
  },
  {
    icon: { name: 'clear', color: Colors.SecondaryRed },
    text: 'This role cannot edit the company profile',
  },
];

export const adminPermissions = [
  {
    icon: { name: 'checkmark-fill-circle', color: Colors.SecondaryGreen },
    text: 'This role can explore and interact with talent',
  },
  {
    icon: { name: 'checkmark-fill-circle', color: Colors.SecondaryGreen },
    text: 'This role can manage team members',
  },
  {
    icon: { name: 'clear', color: Colors.SecondaryRed },
    text: 'This role cannot manage billing',
  },
  {
    icon: { name: 'checkmark-fill-circle', color: Colors.SecondaryGreen },
    text: 'This role can edit the company profile',
  },
];

export const ownerPermissions = [
  {
    icon: { name: 'checkmark-fill-circle', color: Colors.SecondaryGreen },
    text: 'This role can explore and interact with talent',
  },
  {
    icon: { name: 'checkmark-fill-circle', color: Colors.SecondaryGreen },
    text: 'This role can manage team members',
  },
  {
    icon: { name: 'checkmark-fill-circle', color: Colors.SecondaryGreen },
    text: 'This role can manage billing',
  },
  {
    icon: { name: 'checkmark-fill-circle', color: Colors.SecondaryGreen },
    text: 'This role can edit the company profile',
  },
];

export const ROLES = [
  { value: 'default', name: '' }, { value: 'manager', name: 'Manager' }, { value: 'admin', name: 'Admin' }, { value: 'owner', name: 'Owner' },
];
